import React from 'react';

import { ReactFCC } from '@types';

export interface IGeneralProductItemContext {
  itemQuantity: number;
  maximumQuantity: number;
  price: number;
  disabled: boolean;
  isDualPriceLayout: boolean;
  isSummaryLayout?: boolean;
  priceHistory?: number | null;
}

const defaultContextValue: IGeneralProductItemContext = {
  itemQuantity: 0,
  maximumQuantity: 0,
  price: 0,
  disabled: true,
  isDualPriceLayout: false,
  isSummaryLayout: false,
  priceHistory: null,
};

const GeneralProductItemContext = React.createContext<IGeneralProductItemContext>(defaultContextValue);
GeneralProductItemContext.displayName = 'GeneralProductItemContext';

export const GeneralProductItemProvider: ReactFCC<IGeneralProductItemContext> = ({ children, ...props }) => {
  const value = React.useMemo(
    () => ({
      ...props,
    }),
    [props],
  );
  return <GeneralProductItemContext.Provider value={value}>{children}</GeneralProductItemContext.Provider>;
};

export const useGeneralProductItemContext = () => React.useContext(GeneralProductItemContext);
